module.exports = __webpack_public_path__ + "img/kelly-y.8c3d909b.jpg";